import "./About.css";

const About = (props) => {
  const { onLogin } = props;
  return (
    <div className="unauthed-home-container">
      <div className="unauthed-home-container-title">
        <h2>How It Works</h2>
      </div>
      <ol>
        <li>
          <strong>Import Your Content:</strong> Easily upload your newsletters
          or articles into Newsie CMS.
        </li>
        <li>
          <strong>Generate Interactive Elements:</strong> Use our AI tools to
          create engaging puzzles, games, and quizzes in seconds.
        </li>
        <li>
          <strong>Customize for Your Brand:</strong> Adjust the design and
          content to fit your publication’s style and tone.
        </li>
        <li>
          <strong>Embed and Publish:</strong> Seamlessly integrate the
          interactive content into your newsletters or articles.
        </li>
        <li>
          <strong>Analyze and Optimize:</strong> Track engagement metrics and
          gain insights to continually improve your content strategy.
        </li>
      </ol>
    </div>
  );
};

export default About;
